{
  "en": "Inglês",
  "de": "Alemão",
  "fr": "Francês",
  "es": "Espanhol",
  "cs": "Tcheco",
  "da": "Dinamarquês",
  "et": "Estoniano",
  "fi": "Finlandês",
  "hr": "Croata",
  "hu": "Húngaro",
  "it": "Italiano",
  "lt": "Lituano",
  "lv": "Letão",
  "nl": "Holandês",
  "nb": "Norueguês Bokmål",
  "pl": "Polonês",
  "pt": "Português",
  "ro": "Romeno",
  "sk": "Eslovaco",
  "sl": "Esloveno",
  "sq": "Albanês",
  "sv": "Sueco"
}
